import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { PermissionGrantReportsData } from './PermissionGrantReportsData.types.tsx';

const RESOURCE_TYPE_PERMISSION_GRANT_PROJECTS_LIMITS = 'PERMISSION_GRANT_PROJECTS_LIMITS';

export const permissionGrantProjectsLimitsResource: RouteResource<PermissionGrantReportsData> =
	createResource<PermissionGrantReportsData>({
		type: RESOURCE_TYPE_PERMISSION_GRANT_PROJECTS_LIMITS,
		getKey: () => 'permissionGrantProjectsLimits',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-permission-grant-projects-limits", jiraSpaEntry: "async-resource-permission-grant-projects-limits" */ './getPermissionGrantData.tsx'
			),
	});
